import type { FooterProps } from '@sravni/react-footer';
import { Footer } from '@sravni/react-footer';

import { useAppSelector } from 'shared/lib/redux';

import { selectIsMarketplaceEnabled, selectSiteSettingsFooter } from 'entities/siteSettings';

type Props = {
  variant?: FooterProps['variant'];
};

export const MainPageFooter: FC<Props> = (props) => {
  const { variant = 'primary' } = props;
  const isMarketplaceEnabled = useAppSelector(selectIsMarketplaceEnabled);

  const footer = useAppSelector(selectSiteSettingsFooter);

  return (
    <Footer
      menuLinks={footer?.menu}
      socialLinks={footer?.socialLinks}
      support={footer?.support}
      companyName={isMarketplaceEnabled ? 'mpl' : undefined}
      variant={variant}
    />
  );
};
